import { createStore } from '@stencil/store';
import { doc } from 'firebase/firestore';
import { EMPTY, Subscription, catchError, skipWhile } from 'rxjs';
import { docData } from 'rxfire/firestore';
import spacetime from 'spacetime';

import { FirebaseService } from '../utils/firebase';
import { selection } from './selection.store';
import { settings } from './settings.store';

import { ScheduleDate } from '@artask/tambr-models/models/schedule.model';



interface State {
  availableDatesLoading: boolean;
  availableDatesLoaded: boolean;
  availableDates: string[];
  availableDatesSubscription: Subscription;

  dateScheduleLoading: boolean;
  dateScheduleLoaded: boolean;
  dateSchedule: ScheduleDate;
  dateScheduleSubscription: Subscription;
}

const { state, onChange } = createStore<State>({
  availableDatesLoading: false,
  availableDatesLoaded: false,
  availableDates: [],
  availableDatesSubscription: null,

  dateScheduleLoading: false,
  dateScheduleLoaded: false,
  dateSchedule: null,
  dateScheduleSubscription: null
});

onChange( 'dateScheduleLoading', (loading) => console.log('ScheduleDate loading', loading) );


function setAvailableDatesListener() {
  if ( !settings.businessId ) return;

  try {
    state.availableDatesLoading = true;
    state.availableDatesSubscription = docData( 
      doc( FirebaseService.firestore, `businesses/${ settings.businessId }/schedule/dates` )
    ).pipe(
      skipWhile( () => settings.appCheckFailed ),
      catchError( error => {
        console.error( 'Error fetching dates:', error );
        return EMPTY;
      })
    ).subscribe( (datesDoc: { dates: string[]; }) => { 
      if ( datesDoc?.dates ) {
        state.availableDatesLoaded = true;
        state.availableDatesLoading = false;
        state.availableDates = datesDoc.dates.sort(); // make sure it's sorted
        const isActiveDatePast = spacetime( selection.date ).isBefore( spacetime( state.availableDates[0] ) );
        if ( !selection.date || isActiveDatePast ) selection.date = state.availableDates[0];
      }
    } );
  } catch (error) {
    console.error( 'Error fetching dates:', error );
    state.availableDatesLoading = false;
  }
}


function setDateScheduleListener( date: string ) {
  if ( !date || !settings.businessId ) return;

  try { 
    state.dateScheduleLoading = true;
    if ( state.dateScheduleSubscription ) state.dateScheduleSubscription.unsubscribe();
    state.dateScheduleSubscription = docData( 
      doc( FirebaseService.firestore, `businesses/${ settings.businessId }/schedule/${ date }` )
    ).pipe(
      skipWhile( () => settings.appCheckFailed ),
      catchError( error => {
        console.error( 'Error fetching schedule:', error );
        return EMPTY;
      })
    ).subscribe( (doc: ScheduleDate) => {
      console.log('setDateScheduleListener', doc);
      state.dateSchedule = doc;
      state.dateScheduleLoaded = true;
      state.dateScheduleLoading = false;
    });
  } catch(e) {
    console.log( 'setDateScheduleListener error', e );
  }
}


function stopScheduleListeners() {
  if ( state.availableDatesSubscription ) state.availableDatesSubscription.unsubscribe();
  if ( state.dateScheduleSubscription ) state.dateScheduleSubscription.unsubscribe();
}

export { 
  state as schedule,
  setAvailableDatesListener,
  setDateScheduleListener,
  stopScheduleListeners
};